import { getInfo } from '@/api/taxes'
import { defineStore } from 'pinia'

const useTaxes = defineStore(
  'TAXES_STORE',
  () => {
    const tid = ref('')
    const setTid = (val) => {
      tid.value = val
    }

    const extraQuery = ref({})
    const setExtraQuery = (val) => {
      extraQuery.value = val
    }

    const info = ref({})
    const setInfo = (data) => {
      info.value = data
    }
    const resetInfo = async () => {
      const loading = ElLoading.service({
        lock: true,
        text: 'Loading...',
        background: 'rgba(255, 255, 255, 0.5)'
      })
      try {
        const res = await getInfo({ tid: tid.value, ...extraQuery.value })
        setInfo(res.data || {})
      } finally {
        loading.close()
      }
    }

    return { tid, setTid, extraQuery, setExtraQuery, info, setInfo, resetInfo }
  },
  {
    persist: {
      storage: localStorage
    }
  }
)

export default useTaxes
